export default "__VITE_ASSET__Cgtju0NI__"